import React, { useRef, useEffect, useState } from 'react';
import Link from 'next/link';
import ReactHtmlParser from 'react-html-parser';
import striptags from 'striptags';
import throttle from 'lodash.throttle';

import { LOGO_URL } from '../../services/logoUrl';
import ButtonHref from '../Button/ButtonHref';

import * as S from './ArticleFromServices.sc';

import ArticleTitle from '../ArticleTitle/ArticleTitle';
import {
  replaceDomainToTap,
  getRelativeArticlePath,
} from '../../services/urlString';

const ArticleFromServices = ({ article, addShadow, visibleOnload }) => {
  const [articleVisible, setArtcleVisible] = useState(visibleOnload);
  const articleRef = useRef(null);
  const originDomain = article.get_external_url.includes('agrarlex.pl');
  useEffect(() => {
    document.addEventListener('scroll', trackScrolllingThrottle);
    return () => {
      document.removeEventListener('scroll', trackScrolllingThrottle);
    };
  }, []);
  const isTop = (el) => {
    return el ? el.getBoundingClientRect().top <= window.innerHeight : false;
  };
  const trackScrollling = () => {
    const element = articleRef.current;
    if (isTop(element)) {
      setArtcleVisible(true);
    }
  };

  const trackScrolllingThrottle = throttle(trackScrollling, 400);
  const croppedImage = article.crops.find((el) => el.ratio === '800x400');
  return (
    <S.Container addShadow={addShadow} show={articleVisible} ref={articleRef}>
      <ArticleTitle article={article} showShareButtons={!addShadow} />
      <S.Row>
        <S.ImgContainer>
          {!originDomain && (
            <S.SitesLabel>
              <S.Logo src={LOGO_URL[article.site.id]} />
            </S.SitesLabel>
          )}
          {article.image_cropped && (
            <S.MainImage
              src={replaceDomainToTap(
                croppedImage?.image || article.image_cropped
              )}
            />
          )}
        </S.ImgContainer>
        <S.Lead>{striptags(article.lead)}</S.Lead>
        <S.ArticleContent className="wysiwyg">
          {ReactHtmlParser(article.body_split[0])}
        </S.ArticleContent>

        {originDomain ? (
          <Link
            href={'/artykuly/[category]/[article]'}
            as={getRelativeArticlePath(article.get_external_url)}
            passHref={true}
          >
            <S.WhiteLink>
              <ButtonHref
                type={'gradient'}
                color={'blue'}
                customStyle={{ margin: 0 }}
              >
                CZYTAJ ARTYKUŁ
              </ButtonHref>
            </S.WhiteLink>
          </Link>
        ) : (
          <S.WhiteLink href={article.get_external_url}>
            <ButtonHref
              type={'gradient'}
              color={'green'}
              customStyle={{ margin: 0 }}
            >
              CZYTAJ CAŁY ARTYKUŁ W {article.site.domain}
            </ButtonHref>
          </S.WhiteLink>
        )}
      </S.Row>
    </S.Container>
  );
};

export default ArticleFromServices;
